import classNames from 'classnames';
import React, { forwardRef } from 'react';
import Logo from '@/components/atoms/logo/logo';
import Typography from '@/components/atoms/typography/typography';
import Radiobutton from '@/components/molecules/radiobutton/radiobutton';
import styles from './altapay-payment-method.module.scss';

export interface AltapayPaymentMethodProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'required'> {
  /** Indicates whether the field is checked */
  checked?: boolean;
  /** Indicates whether the field is disabled */
  disabled?: boolean;
  /** Identification for the radio button */
  id?: string;
  /** The rich text that is shown to the right of the field */
  label: string;
  /** An event that is triggered on change */
  onChange?: () => void;
  /** Indicates whether the field is required */
  required?: boolean;
  /** The value of the field */
  value?: string;
}

const paymentMethodMap: Record<
  'Dankort' | 'Mastercard' | 'Mobilepay',
  'Dankort' | 'Mastercard' | 'MobilePay'
> = {
  Dankort: 'Dankort',
  Mastercard: 'Mastercard',
  Mobilepay: 'MobilePay',
};

const AltapayPaymentMethod = forwardRef<
  HTMLInputElement,
  AltapayPaymentMethodProps
>(
  (
    { checked = false, children, className, disabled = false, label, ...rest },
    ref,
  ) => {
    return (
      <div
        className={classNames(styles.component, className, {
          [styles.isChecked]: checked,
          [styles.isDisabled]: disabled,
        })}
      >
        <label className={styles.label}>
          <span className={styles.inputWrapper}>
            <input
              {...rest}
              ref={ref}
              checked={checked}
              className={styles.input}
              disabled={disabled}
              type="radio"
            />

            {rest.value && (
              <Logo
                className={styles.logo}
                name={paymentMethodMap[rest.value]}
              />
            )}

            <span className={styles.text}>
              <Typography tagStyle="bodyMediumBold">{label}</Typography>

              <Typography tagStyle="bodyMedium">DKK {children}</Typography>
            </span>

            <Radiobutton
              checked={checked}
              disabled={disabled}
              onChange={() => undefined}
            />
          </span>
        </label>
      </div>
    );
  },
);

AltapayPaymentMethod.displayName = 'AltapayPaymentMethod';

export default AltapayPaymentMethod;
